import { type ReactElement } from 'react';
import { Text } from '@avanta/shared/components/Text';

interface EmptyContentProps {
  emptyTitle?: string;
  emptyMessage?: string;
}

export const EmptyContent = ({ emptyTitle, emptyMessage }: EmptyContentProps): ReactElement => (
  <div className="flex flex-col items-center justify-center py-12 w-full">
    <div className="flex flex-col items-center gap-2">
      {emptyTitle && (
        <Text tag="h3" variant="text-sm-regular" className="text-denim-500">
          {emptyTitle}
        </Text>
      )}
      {emptyMessage && (
        <Text variant="text-xs-regular" className="text-gray-500">
          {emptyMessage}
        </Text>
      )}
    </div>
  </div>
);
